import { SortableContext, useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { useMemo, useState } from "react";
import KanbanTaskCard from "./kanban-task-card";
import { DictType } from "@pma/types";

interface Props {
  column: any;
  deleteColumn: (id: any) => void;
  updateColumn: (id: any, title: string) => void;
  createTask: (columnId: any) => void;
  updateTask: (id: any, content: string) => void;
  deleteTask: (id: any) => void;
  tasks: any[];
}

function ColumnContainer({
  column,
  deleteColumn,
  updateColumn,
  createTask,
  tasks,
  deleteTask,
  updateTask,
}: Props) {
  const [editMode, setEditMode] = useState(false);

  const tasksIds = useMemo(() => {
    return tasks?.map((task) => task.id);
  }, [tasks]);

  const {
    setNodeRef,
    attributes,
    listeners,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: column.id,
    data: {
      type: "Column",
      column,
    },
    disabled: editMode,
  });

  const backgroundColor = useMemo(() => {
    // Extract the hex color from column.color, assuming it's in the format #RRGGBB
    const hexColor = column?.color?.slice(1); // Remove the '#' character
    const r = parseInt(hexColor?.substring(0, 2), 16);
    const g = parseInt(hexColor?.substring(2, 4), 16);
    const b = parseInt(hexColor?.substring(4, 6), 16);

    // Return the rgba string with 80% opacity (0.8)
    return `rgba(${r}, ${g}, ${b}, 0.5)`;
  }, [column?.color]);
  const style = {
    transition,
    transform: CSS.Transform.toString(transform),
  };

  if (isDragging) {
    return (
      <div
        ref={setNodeRef}
        style={style}
        className="flex h-[500px] max-h-[500px] w-[350px] flex-col rounded-md border-2 border-pink-500 bg-primary/50 opacity-40"
      ></div>
    );
  }

  return (
    <div
      ref={setNodeRef}
      style={{
        ...style,
        background: backgroundColor,
      }}
      className="flex max-h-[700px] min-h-[500px] w-[350px] flex-col rounded-md "
    >
      {/* Column title */}
      <div
        {...attributes}
        {...listeners}
        className="text-md flex h-[60px] cursor-grab items-center justify-between rounded-md rounded-b-none border-1 border-primary  p-3 font-bold"
      >
        <div className="w-full gap-2 text-center">
          {column.title}
          {/* ---{column?.id} */}
        </div>
      </div>

      {/* Column task container */}
      <div className="flex flex-grow flex-col gap-4 overflow-y-auto overflow-x-hidden p-2">
        <SortableContext items={tasksIds}>
          {/* {column?.tasks?.map((task: DictType) => (
            <KanbanTaskCard
              key={task.id}
              task={task}
              deleteTask={deleteTask}
              updateTask={updateTask}
            />
          ))} */}
          {tasks?.map((task: DictType) => (
            <KanbanTaskCard
              key={task.id}
              task={task}
              deleteTask={deleteTask}
              updateTask={updateTask}
            />
          ))}
        </SortableContext>
      </div>
      {/* Column footer */}
      {/* <button
        className="border-columnBackgroundColor border-x-columnBackgroundColor hover:bg-mainBackgroundColor flex items-center gap-2 rounded-md border-2 p-4 hover:text-rose-500 active:bg-black"
        onClick={() => {
          createTask(column.id);
        }}
      >
        <PlusIcon />
        Add task
      </button> */}
    </div>
  );
}

export default ColumnContainer;
